import React from 'react';
const CompanyProfileConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/apps/company-forms',
			component: React.lazy(() => import('./customerForms/companyProfile.js'))
		},
		{
			path: '/apps/company-profile',
			component: React.lazy(() => import('./customerAccounts/customerAccounts.js'))
		},
		{
			path: '/apps/dashboard',
			component: React.lazy(() => import('../superAdminDashboard/SuperAdminDashboard'))
		},
		{
			path: '/apps/company-details',
			component: React.lazy(() => import('./customerAccountDetails/CustomerAccountDetails.js'))
		},
		{
			path: '/apps/company-details/Profile',
			component: React.lazy(() => import('./customerAccountDetails/SideNavigationPages/Profile/Index.js'))
		},
		{
			path: '/apps/company-details/Contact',
			component: React.lazy(() => import('./customerAccountDetails/SideNavigationPages/contact/Contact.js'))
		},
		{
			path: '/apps/company-details/configration',
			component: React.lazy(() => import('./customerAccountDetails/SideNavigationPages/configration/config.js'))
		},
		{
			path: '/apps/company-details/Agents',
			component: React.lazy(() => import('./customerAccountDetails/SideNavigationPages/agents/AgentTable.js'))
		},
		{
			path: '/apps/company-details/CannedReplies',
			component: React.lazy(() => import('./customerAccountDetails/SideNavigationPages/CannedReplies/Index.js'))
		},
		{
			path: '/apps/company-details/autoReply',
			component: React.lazy(() =>
				import('./customerAccountDetails/SideNavigationPages/autoReply/autoReplyTable.js')
			)
		},
		{
			path: '/apps/addAutoReply',
			component: React.lazy(() => import('./customerAccountDetails/SideNavigationPages/autoReply/autoReplyTable'))
		},
		{
			path: '/apps/company-details/autoReply/calls',
			component: React.lazy(() =>
				import('./customerAccountDetails/SideNavigationPages/autoReplyCalls/AutoReplyCalls.js')
			)
		},
		{
			path: '/apps/company-details/client-call-config',
			component: React.lazy(() =>
				import('./customerAccountDetails/SideNavigationPages/clientAIConfig/ClientAIConfig.js')
			)
		},
		{
			path: '/apps/company-details/eleven-labs-agent',
			component: React.lazy(() =>
				import('./customerAccountDetails/SideNavigationPages/elevenLabsAgent/ElevenLabsAgent.js')
			)
		},
		{
			path: '/apps/company-details/call-interactions',
			component: React.lazy(() =>
				import('./customerAccountDetails/SideNavigationPages/callInteractions/CallInteractions.js')
			)
		},
		{
			path: '/apps/company-details/custom_api',
			component: React.lazy(() => import('./customerAccountDetails/SideNavigationPages/CustomApi/customApi.js'))
		},
		{
			path: '/apps/company-details/Tagsforchatbot',
			component: React.lazy(() => import('./customerAccountDetails/SideNavigationPages/AddTagsForChatbot/AddTags.js'))
		},
		{
			path: '/apps/company-details/mau',
			component: React.lazy(() => import('./customerAccountDetails/SideNavigationPages/Mau/mau.js'))
		},
		{
			path: '/apps/company-details/nearest-location',
			component: React.lazy(() => import('./customerAccountDetails/SideNavigationPages/LocationUpdate/Index.js'))
		},
		{
			path: '/apps/company-details/reminderMessage',
			component: React.lazy(() => import('./customerAccountDetails/SideNavigationPages/reminderMessage/ReminderMsg.js'))
		},
		{
			path: '/apps/company-details/segments',
			component: React.lazy(() => import('./customerAccountDetails/SideNavigationPages/segments/Segment.js'))
		},
		{
			path: '/apps/company-details/uat-customer',
			component: React.lazy(() => import('./customerAccountDetails/SideNavigationPages/uatCustomer/UATCustomer.js'))
		},
		{
			path: '/apps/company-details/sms-provider',
			component: React.lazy(() => import('./customerAccountDetails/SideNavigationPages/smsProvider/SMSProvider.js'))
		},
		{
			path: '/apps/company-details/catalouges',
			component: React.lazy(() => import('./customerAccountDetails/SideNavigationPages/Catalouge/CatalougeTable'))
		},
		{
			path: '/apps/company-details/products',
			component: React.lazy(() => import('./customerAccountDetails/SideNavigationPages/Products/ProductsTable.js'))
		},
		{
			path: '/apps/company-details/orders',
			component: React.lazy(() => import('./customerAccountDetails/SideNavigationPages/Orders/OrdersTable'))
		},
		{
			path: '/apps/company-details/templateMessage-hsm',
			component: React.lazy(() => import('../setting/TemplateMessages/Template.js'))
		},
		{
			path: '/apps/company-details/analytics',
			component: React.lazy(() => import('../setting/TemplateMessages/Template.js'))
		},
		{
			path: '/apps/company-details/template-analytics',
			component: React.lazy(() => import('../setting/TemplateMessages/Template.js'))
		},
		{
			path: '/apps/company-details/email/campaigns',
			component: React.lazy(() => import('../EmailCampaign/EmailCampaign.js'))
		},
		{
			path: '/apps/company-details/email-inbox/limit',
			component: React.lazy(() =>
				import(
					'./customerAccountDetails/SideNavigationPages/emailInboxLimit/EmailInboxLimit.js'
				)
			)
		},
		{
			path: '/apps/company-details/chatbot/analytics',
			component: React.lazy(() => import('../ChatbotAnalytics/ChatbotAnalytics.js'))
		},
		{
			path: '/apps/company-details/limits',
			component: React.lazy(() =>
				import(
					'./customerAccountDetails/SideNavigationPages/messageLimitsAndQuotaManagement/MessageLimitsAndQuotaManagement.js'
				)
			)
		},
		{
			path: '/apps/company-details/messages',
			component: React.lazy(() => import('./customerAccountDetails/SideNavigationPages/messages/MessagesTable.js'))
		},
		{
			path: '/apps/company-details/agent-avg-time',
			component: React.lazy(() =>
				import('./customerAccountDetails/SideNavigationPages/reports/AgentAvgTimeReport.js')
			)
		},
		{
			path: '/apps/company-details/chat-report',
			component: React.lazy(() =>
				import('./customerAccountDetails/SideNavigationPages/reports/ChatReport.js')
			)
		},
		{
			path: '/apps/company-details/sub-account',
			component: React.lazy(() =>
				import('./customerAccountDetails/SideNavigationPages/reports/SubAccountReport.js')
			)
		},
		{
			path: '/apps/company-details/agent-report',
			component: React.lazy(() =>
				import('./customerAccountDetails/SideNavigationPages/reports/AgentReport.js')
			)
		},
		{
			path: '/apps/company-details/customer-feedback',
			component: React.lazy(() =>
				import('./customerAccountDetails/SideNavigationPages/reports/CustomerFeedbackReport.js')
			)
		},
		{
			path: '/apps/company-details/customer-journey',
			component: React.lazy(() =>
				import('./customerAccountDetails/SideNavigationPages/reports/CustomerJourneyReport.js')
			)
		},
		{
			path: '/apps/company-details/average-handling-time',
			component: React.lazy(() =>
				import('./customerAccountDetails/SideNavigationPages/reports/AverageHandlingTimeReport.js')
			)
		},
		{
			path: '/apps/company-details/service-levels',
			component: React.lazy(() =>
				import('./customerAccountDetails/SideNavigationPages/reports/ServiceLevelsReport.js')
			)
		},
		{
			path: '/apps/company-details/hourly-chat-logs',
			component: React.lazy(() =>
				import('./customerAccountDetails/SideNavigationPages/reports/HourlyChatLogsReport.js')
			)
		},
		{
			path: '/apps/company-details/otp-logs',
			component: React.lazy(() =>
				import('./customerAccountDetails/SideNavigationPages/reports/OtpLogsReport.js')
			)
		},
		{
			path: '/apps/company-details/inbox/tickets',
			component: React.lazy(() =>
				import('./customerAccountDetails/SideNavigationPages/inbox/superAdmin/SaInboxTickets.js')
			)
		},
		{
			path: '/apps/company-details/inbox/ticket-history',
			component: React.lazy(() =>
				import('./customerAccountDetails/SideNavigationPages/inbox/superAdmin/SaTicketHistory.js')
			)
		},
		{
			path: '/apps/company-details/inbox/ongoing',
			component: React.lazy(() =>
				import('./customerAccountDetails/SideNavigationPages/inbox/superAdmin/SaOngoingTickets.js')
			)
		},
		{
			path: '/apps/company-details/inbox/overall-history',
			component: React.lazy(() =>
				import('./customerAccountDetails/SideNavigationPages/inbox/superAdmin/SaOverallHistory.js')
			)
		},
		{
			path: '/apps/company-details/inbox/ticket-reports',
			component: React.lazy(() => import('./customerAccountDetails/SideNavigationPages/inbox/TicketReportTable.js'))
		},
		{
			path: '/apps/company-details/inbox/complain',
			component: React.lazy(() => import('./customerAccountDetails/SideNavigationPages/inbox/TicketsComplainTable.js'))
		},
		{
			path: '/apps/company-details/inbox/complain-report',
			component: React.lazy(() => import('./customerAccountDetails/SideNavigationPages/inbox/ComplainReportTable.js'))
		},
		{
			path: '/apps/company-details/channels',
			component: React.lazy(() => import('./customerAccountDetails/SideNavigationPages/channels/ChannelsList.js'))
		},
	]
};

export default CompanyProfileConfig;